import {Component, OnInit} from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {UserSubject} from "../../../subject/user.subject";
import {ResponseDto} from "../../../dto/response.dto";
import {UserService} from "../../../services/user.service";
import {UserInformationDto} from "../../../dto/user.information.dto";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    loginForm!: FormGroup;
    registerForm!: FormGroup;
    isLoginMode: boolean = true;
    loading: boolean = false;
    isNotDataValid: boolean = false;
    // Mensaje del diálogo para mostrar error
    dialogMessage: string = '';
    // Variable para obtener el codigo de error y mostrar en el diálogo
    dialogCode: string | undefined;
    // Variable para mostrar diálogo de errores
    showErrorDialog = false;
    userInformationDto: UserInformationDto | undefined;

    constructor(
        private authService: AuthService,
        private router: Router,
        private fb: FormBuilder,
        private userSubject: UserSubject,
        private userService: UserService
    ) {}

    ngOnInit(): void {
        this.initForms();
    }

    initForms() {
        this.loginForm = this.fb.group({
            username: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.minLength(6)]],
        });

        this.registerForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
            registerPassword: ['', [Validators.required, Validators.minLength(6)]],
            newsletter: [false],
            termsAccepted: [false, [Validators.requiredTrue]],
        });
    }

    setLoginMode(isLogin: boolean) {
        this.isLoginMode = isLogin;
        this.isNotDataValid = false;
        this.showErrorDialog = false;
    }

    onLogin() {
        this.showErrorDialog = false;
        this.isNotDataValid = false;
        if (this.loginForm.invalid) {
            this.isNotDataValid = true;
            console.error('Formulario inválido');
            return;
        }
        this.loading = true;
        const { username, password } = this.loginForm.value;
        this.authService.login(username, password).subscribe({
            next: (response) => {
                this.loading = false;
                this.getUserInfoService();
            },
            error: (error) => {
                console.error('Login error:', error);
                this.loading = false;
                this.handleLoginError(error);
            }
        });
    }

    getUserInfoService(){
        this.userService.getUserInfo().subscribe(
            response => {
                this.userInformationDto = response;
                if(this.userInformationDto){
                    if(this.userInformationDto.verifiedCellphone || this.userInformationDto.verifiedEmail || this.userInformationDto.verifiedIdentity){
                        this.router.navigate(['/register-document']);  // Redirigir al dashboard
                    }
                    this.router.navigate(['/profile']);
                }
                console.log('Información del usuario', this.userInformationDto);
            }, error => {
                console.error('Error al obtener la información del usuario', error);
            });
    }

    register() {
        this.showErrorDialog = false;
        if (this.registerForm.invalid) {
            this.isNotDataValid = true;
            return;  // Detener la ejecución si el formulario no es válido
        }

        this.loading = true;
        const { email, registerPassword, newsletter,termsAccepted } = this.registerForm.value;

        this.userSubject.updateRegistrationData({
            accountEmail: email,
            accountPassword: registerPassword,
            accountPasswordConfirmation: registerPassword,
            emailSubscription: newsletter,
            acceptance: termsAccepted
        });
        const finalData = this.userSubject.getRegistrationData() || {};
        console.log('Final data:', finalData);
        this.userService.accountDataValidation(finalData).subscribe(
            (response) => {
                console.log('Registro exitoso', response);
                this.router.navigate(['/register']);
                this.loading = false;
            },
            (error) => {
                console.error('Error en el registro', error);
                this.loading = false;
                this.responseHandler(error);
            }
        );
    }

    getValidationMessages(state: any, thingName?: string) {
        const thing: string | undefined = thingName;
        const messages: string[] = [];
        if (state.errors != null) {
            for (const errorName of Object.keys(state.errors)) {
                switch (errorName) {
                    case 'required':
                        messages.push(`El campo ${thing} es requerido.`);
                        break;
                    case 'minlength':
                        messages.push(`El campo ${thing} debe ser al menos ${state.errors.minlength.requiredLength} caracteres.`);
                        break;
                    case 'maxlength':
                        messages.push(`El campo de ${thing} no debe ser mayor a ${state.errors.maxLength.requiredLength} caracteres.`);
                        break;
                    case 'pattern':
                        messages.push(`El campo ${thing} contiene caracteres inválidos.`);
                        break;
                    case 'email':
                        messages.push(`El campo ${thing} debe ser correo electrónico.`);
                        break;
                    case 'min':
                        messages.push(`El importe debe ser 1.00 como mínimo.`);
                        break;
                }
            }
        }
        return messages;
    }
    handleLoginError(error: any) {
        const responseDto: ResponseDto = {
            errorDetail: error.message || 'Error de autenticación.',
            response: '',
            statusCode: error.status || '401',
            httpStatus: error.status || '401'
        };
        this.responseHandler(responseDto);
    }

    responseHandler(responseDto: ResponseDto) {
        console.log('error responseHandler: ', responseDto, responseDto.errorDetail, responseDto.statusCode);
        console.log('error: ', responseDto.errorDetail, 'error: ', responseDto.statusCode);
        this.dialogDisplayError(responseDto.errorDetail, responseDto.statusCode);
    }

    dialogDisplayError(error: string | null, status: string) {
        this.showErrorDialog = true;
        this.dialogMessage = error ?? '';  // Si error es null, asignar cadena vacía
        this.dialogCode = status;
        console.log('Error:', error, 'Status:', status, 'Dialog message:', this.dialogMessage, 'Dialog code:', this.dialogCode);
    }
}


